var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcGrammarGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.34496 1.87599C7.37353 1.72306 7.45468 1.58493 7.57436 1.48553C7.69404 1.38614 7.84472 1.33173 8.00029 1.33173C8.15587 1.33173 8.30655 1.38614 8.42623 1.48553C8.54591 1.58493 8.62706 1.72306 8.65563 1.87599L9.35629 5.58132C9.40606 5.84475 9.53408 6.08707 9.72365 6.27664C9.91322 6.46621 10.1555 6.59423 10.419 6.64399L14.1243 7.34466C14.2772 7.37322 14.4154 7.45437 14.5147 7.57405C14.6141 7.69374 14.6686 7.84441 14.6686 7.99999C14.6686 8.15557 14.6141 8.30624 14.5147 8.42592C14.4154 8.54561 14.2772 8.62676 14.1243 8.65532L10.419 9.35599C10.1555 9.40575 9.91322 9.53377 9.72365 9.72334C9.53408 9.91291 9.40606 10.1552 9.35629 10.4187L8.65563 14.124C8.62706 14.2769 8.54591 14.415 8.42623 14.5144C8.30655 14.6138 8.15587 14.6683 8.00029 14.6683C7.84472 14.6683 7.69404 14.6138 7.57436 14.5144C7.45468 14.415 7.37353 14.2769 7.34496 14.124L6.64429 10.4187C6.59453 10.1552 6.46651 9.91291 6.27694 9.72334C6.08737 9.53377 5.84506 9.40575 5.58163 9.35599L1.87629 8.65532C1.72336 8.62676 1.58524 8.54561 1.48584 8.42592C1.38644 8.30624 1.33203 8.15557 1.33203 7.99999C1.33203 7.84441 1.38644 7.69374 1.48584 7.57405C1.58524 7.45437 1.72336 7.37322 1.87629 7.34466L5.58163 6.64399C5.84506 6.59423 6.08737 6.46621 6.27694 6.27664C6.46651 6.08707 6.59453 5.84475 6.64429 5.58132L7.34496 1.87599Z",
    stroke: "#065F46",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.333 1.33334V4.00001",
    stroke: "#065F46",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 2.66666H12",
    stroke: "#065F46",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.66634 14.6667C3.40272 14.6667 3.99967 14.0697 3.99967 13.3333C3.99967 12.597 3.40272 12 2.66634 12C1.92996 12 1.33301 12.597 1.33301 13.3333C1.33301 14.0697 1.92996 14.6667 2.66634 14.6667Z",
    stroke: "#065F46",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcGrammarGreen);
export default __webpack_public_path__ + "static/media/ic_grammar_green.3eb4e4f2a0a169134c1d995e264467e6.svg";
export { ForwardRef as ReactComponent };